import { makeStyles } from "@material-ui/core";

const useOptimizationReportStyles = makeStyles(theme => ({

     MuiTableContainerRoot:{
         width :70,
     }


}));

export default useOptimizationReportStyles;